function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 59,
  fill: "#0C2C52",
  fillRule: "nonzero",
  rx: 3.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M40.708 35.112c1.364 4.148 0 4.106 0 4.106s-7.51 2.43-11.264 2.43c-3.874 0-11.621-2.43-11.621-2.43l-.027-.045c-.158-.278-.928-1.822.027-4.06 1.056-2.48 2.611-4.99 5.549-4.304 2.069 1.49 4.3 4.434 5.893 4.434 1.893 0 4.768-3.308 7.163-4.434 2.377-1.118 2.916.155 4.28 4.303zM29.334 17.353c3.007 0 5.445 2.926 5.445 6.535s-2.438 6.535-5.445 6.535c-3.008 0-5.446-2.926-5.446-6.535 0-3.61 2.438-6.535 5.446-6.535z"
}));

function SvgIconSso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSso);
export default __webpack_public_path__ + "static/media/icon-sso.a583d6fa.svg";
export { ForwardRef as ReactComponent };